import { takeEvery, call, put, fork } from "redux-saga/effects";
import * as actions from "../actions/AMActions";
import * as api from "../../api/autonomousMaintenanceApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getAreaList() {
    try {
        const { data } = yield api.getAreaList();
        yield put(actions.setAreaList(data || undefined));
    } catch (error) {
        yield put(actions.setAreaList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getMaintenanceType() {
    try {
        const { data } = yield api.getMaintenanceType();
        yield put(actions.setMaintenanceType(data || undefined));
    } catch (error) {
        yield put(actions.setMaintenanceType(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* deleteOrderAM(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deleteOrderAM(action.payload);
        yield put(actions.deleteAMOrderSuccess(data || undefined));
        yield put(actions.resetDeleteOrderAM());
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.deleteAMOrderSuccess(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getAMGetOrderDetailById(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getAMGetOrderDetailById(action.payload.id);
        yield put(actions.setAMGetOrderDetailById({ data, showDates: action.payload.showDates } || undefined));
        yield put(actions.resetAMGetOrderDetailById());
    } catch (error) {
        yield put(actions.setAMGetOrderDetailById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* postAMCreateOrder(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.postAMCreateOrder(action.payload);
        yield put(actions.postAMCreateOrderSuccess(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.postAMCreateOrderSuccess(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* postAMUpdateOrder(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.postAMUpdateOrder(action.payload);
        yield put(actions.postAMUpdateOrderSuccess(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.postAMUpdateOrderSuccess(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getAMGetOrderFiles(action) {
    try {
        const { data } = yield api.getAMGetOrderFiles(action.payload);
        yield put(actions.setAMGetOrderFiles(data || undefined));
    } catch (error) {
        yield put(actions.setAMGetOrderFiles(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* postAMAddFile(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.postAMAddFile(action.payload);
        yield put(actions.postAMAddFileSuccess(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.postAMAddFileSuccess(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* deleteAMOrder(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deleteAMOrder(action.payload);
        yield put(actions.deleteAMOrderSuccess(data || undefined));
    } catch (error) {
        yield put(actions.deleteAMOrderSuccess(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getAMOrderList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getAMOrderList(action.payload);
        yield put(actions.setAMOrderList(data || undefined));
        yield put(actions.resetAMOrderList());
    } catch (error) {
        yield put(actions.setAMOrderList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getCheckItemGroupsById(action) {
    try {
        const { data } = yield api.getCheckItemGroupsById(action.payload);
        yield put(actions.setCheckItemGroupsById(data || undefined));
    } catch (error) {
        yield put(actions.setCheckItemGroupsById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getCheckItemsForTask(action) {
    try {
        const { data } = yield api.getCheckItemsForTask(action.payload);
        yield put(actions.setCheckItemsForTask(data || undefined));
    } catch (error) {
        yield put(actions.setCheckItemsForTask(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* putCheckItemsForTask(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.putCheckItemsForTask(action.payload);
        yield put(actions.setCheckItemsForTask(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setCheckItemsForTask(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_AREAS, getAreaList);
    yield takeEvery(actions.Types.GET_MAINTENANCE_TYPE, getMaintenanceType);
    yield takeEvery(actions.Types.GET_AM_ORDER_DETAIL_BY_ID, getAMGetOrderDetailById);
    yield takeEvery(actions.Types.AM_CREATE_ORDER, postAMCreateOrder);
    yield takeEvery(actions.Types.AM_UPDATE_ORDER, postAMUpdateOrder);
    yield takeEvery(actions.Types.GET_AM_ORDER_FILES, getAMGetOrderFiles);
    yield takeEvery(actions.Types.DELETE_ORDER_AM, deleteOrderAM);
    yield takeEvery(actions.Types.POST_AM_ADD_FILES, postAMAddFile);
    yield takeEvery(actions.Types.DELETE_AM_ORDER, deleteAMOrder);
    yield takeEvery(actions.Types.GET_AM_ORDER_LIST, getAMOrderList);
    yield takeEvery(actions.Types.GET_CHECKITEMGROUPS_BY_ORDERID, getCheckItemGroupsById);
    yield takeEvery(actions.Types.GET_CHECKITEMS_FOR_TASK, getCheckItemsForTask);
    yield takeEvery(actions.Types.PUT_CHECKITEMS_FOR_TASK, putCheckItemsForTask);
}

const AMSagas = [fork(watchAll)];

export default AMSagas;
